module.exports = __webpack_public_path__ + "img/confirmAppointment.c5cd4738.svg";